import React from 'react';
import { Icon } from './Icon';

export function Card({ children, className = '', onClick }: { children: React.ReactNode; className?: string; onClick?: () => void }) {
  return <section className={`card glass ${className}`} onClick={onClick}>{children}</section>;
}

export function Button({ children, onClick, variant = 'primary', disabled = false, type = 'button', className = '' }: { children: React.ReactNode; onClick?: () => void; variant?: 'primary'|'secondary'|'ghost'|'danger'; disabled?: boolean; type?: 'button'|'submit'; className?: string }) {
  return <button type={type} className={`btn btn-${variant} ${className}`} onClick={onClick} disabled={disabled}>{children}</button>;
}

export function Progress({ value, label }: { value: number; label?: string }) {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  return <div className="progress-wrap">{label && <div className="progress-label"><span>{label}</span><strong>{clamped}%</strong></div>}<div className="progress"><span style={{ width: `${clamped}%` }} /></div></div>;
}

export function Pill({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: 'neutral'|'gold'|'green'|'red'|'blue' }) {
  return <span className={`pill pill-${tone}`}>{children}</span>;
}

export function Metric({ icon, value, label }: { icon: React.ComponentProps<typeof Icon>['name']; value: string|number; label: string }) {
  return <div className="metric"><span className="metric-icon"><Icon name={icon} size={18}/></span><div><strong>{value}</strong><span>{label}</span></div></div>;
}

export function Empty({ title, text }: { title: string; text: string }) {
  return <div className="empty"><div className="empty-dot"/><h3>{title}</h3><p>{text}</p></div>;
}
